import React, { useState } from "react";
import styled from "styled-components";
import { Form, Row, Col } from "antd";
import { Input, Button, Typography, Loading } from "../../core";
import { MixStyle } from "../../styles";
import { addyarnQuality } from "../../helper/utils/api/settings";

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};
const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const AddYarnQuality = ({ getYarnQualities, closeModal, ...rest }) => {
  const companyId = localStorage.getItem("companyId");
  const [yarnQulaity, setYarnQuality] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  const onValuesChange = (changedValues, newYarnQuality) => {
    const { count, type, brand, consize } = newYarnQuality;

    setYarnQuality((prev) => ({
      ...prev,
      companyId,
      count,
      type,
      brand,
      consize,
    }));
  };

  const closeModalHandler = () => {
    closeModal("addyarnQaulityModal");
  };

  const onFinish = (values) => {
    createYarnQuality();
  };

  const createYarnQuality = async () => {
    setIsLoading(true);

    try {
      let response = await addyarnQuality(yarnQulaity);
      closeModalHandler();
      getYarnQualities();
      console.log("response", response);
    } catch (error) {
      console.log("error addyarn quality", error);
    }

    setIsLoading(false);
  };

  const onFinishFailed = () => {};

  return (
    <div>
      {isLoading ? <Loading /> : null}
      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        onValuesChange={onValuesChange}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Count"
              name="count"
              rules={[
                {
                  required: true,
                  message: "Please input count!",
                },
              ]}
            >
              <Input type="number" placeholder="Count" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Type"
              name="type"
              rules={[
                {
                  required: true,
                  message: "Please input type!",
                },
              ]}
            >
              <Input placeholder="Type" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Brand"
              name="brand"
              rules={[
                {
                  required: true,
                  message: "Please input Brand!",
                },
              ]}
            >
              <Input placeholder="Brand" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Cone Size"
              name="consize"
              rules={[
                {
                  required: true,
                  message: "Please input conesize!",
                },
              ]}
            >
              <Input type="number" placeholder="Cone Size" />
            </Form.Item>
          </Col>
          <Col xs={18}>
            <Row type="flex" justify="space-between">
              <Col sm={10}>
                <Button bg="#404E67" type="primary" htmlType="submit">
                  <Typography
                    text="Add"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
              <Col sm={10}>
                <Button bg="#404E67" type="primary" onClick={closeModalHandler}>
                  <Typography
                    text="cancel"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledForm>
    </div>
  );
};

export default AddYarnQuality;
